import { render, staticRenderFns } from "./ChatMiddleUpload.vue?vue&type=template&id=e2f30af4&"
import script from "./ChatMiddleUpload.vue?vue&type=script&lang=js&"
export * from "./ChatMiddleUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports